// Family helpers for the mock EMR: ages, the dependent age limit, coverage tier, and family accumulators.
import { DEPENDENT_AGE_LIMIT } from "./emrData.js";

const inDates = (date, from, to) => (!from || date >= from) && (!to || date <= to);

export const ageOn = (dateOfBirth, date) => {
    if (!dateOfBirth || !date) return null;
    const [birthYear, birthMonth, birthDay] = dateOfBirth.split("-").map(Number);
    const [year, month, day] = date.split("-").map(Number);
    return year - birthYear - (month < birthMonth || (month === birthMonth && day < birthDay) ? 1 : 0);
};

// A child stays covered through the last day of the month they turn 26.
export const agesOutOn = (member) => {
    if (member?.relationship !== "child" || !member.dateOfBirth) return null;
    const [year, month] = member.dateOfBirth.split("-").map(Number);
    return new Date(Date.UTC(year + DEPENDENT_AGE_LIMIT, month, 0)).toISOString().slice(0, 10);
};

export const coveredOn = (member, date) => {
    const limit = agesOutOn(member);
    return inDates(date, member.coverageFrom, member.coverageTo) && (!limit || date <= limit);
};

export const familyMembers = (data, familyId) => (data.members || []).filter((member) => familyId && member.familyId === familyId);

export const coverageTier = (members) => {
    const spouse = members.some((member) => member.relationship === "spouse" || member.relationship === "domesticPartner");
    const children = members.some((member) => member.relationship === "child");
    if (spouse && children) return "Family";
    if (spouse) return "Employee and spouse";
    if (children) return "Employee and children";
    return "Employee only";
};

const FIELDS = {
    inNetwork: { deductible: "deductibleMet", outOfPocket: "outOfPocketMet" },
    outOfNetwork: { deductible: "oonDeductibleMet", outOfPocket: "oonOutOfPocketMet" },
};

// Sums what the other covered family members have met, so the claim can apply the family amounts.
export const familyMet = (data, member, date, side) => {
    const others = familyMembers(data, member?.familyId).filter((item) => item.id !== member.id && coveredOn(item, date));
    const fields = FIELDS[side] || FIELDS.inNetwork;
    return {
        others,
        deductible: others.reduce((sum, item) => sum + Number(item[fields.deductible] || 0), 0),
        outOfPocket: others.reduce((sum, item) => sum + Number(item[fields.outOfPocket] || 0), 0),
    };
};
